import { createSelector } from 'reselect'

export const getUI = state => state.get('ui')

export const getUILogin = createSelector(getUI, ui => ui.get('login'))

export const getUILoginError = createSelector(getUILogin, login => login.get('loginError'))

export const getUILoginEmailError = createSelector(getUILoginError, error => error.get('email'))

export const getUILoginPhoneError = createSelector(getUILoginError, error => error.get('phone'))

export const getUILoginSubmitting = createSelector(getUILogin, login => login.get('submitting'))

export const getUIActivityScreen = createSelector(getUI, UI => UI.get('activityScreen'))

export const getUIUserActivityActionsButtonsDisabled = createSelector(getUIActivityScreen, activityScreen =>
  activityScreen.get('activityActionButtonsDisabled')
)

export const getUIWindowSizes = createSelector(getUI, UI => UI.get('windowSizes'))

export const getUIWindowSizesWidth = createSelector(getUIWindowSizes, sizes => sizes.get('width'))

export const getUIWindowSizesHeight = createSelector(getUIWindowSizes, sizes => sizes.get('height'))
